<template>
  <v-container fluid>
    <v-switch
      class="ml-3"
      v-model="schedulerSwitch"
      :label="`Environment scheduler ${schedulerSwitch ? 'enabled' : 'disabled'}`"
    ></v-switch>

    <v-card id="scheduler" v-if="schedulerSwitch">

      <v-col class="d-flex" cols="12" sm="12">
        <v-list-item-title class="headline mb-1 title cloud-title">Environment scheduler</v-list-item-title>
      </v-col>

      <!-- :items="setRegionsPerProvider"
      item-text="item"
      item-value="value" -->


      <v-col class="d-flex" cols="12" sm="12">
        <v-select
          :menu-props="{offsetY: true }"
          :items="timezones"
          item-text="name"
          item-value="value"
          v-model="selectedTimezone"
          label="Timezone"
          append-icon="fas fa-caret-down"
          :error="errors[0] && !errors[1].timezone.required"
          @change="onSelectedTimezone()"
        ></v-select>
      </v-col>

      <v-stepper class="stepper" non-linear>
        <template>
          <v-stepper-header>
            <template v-for="step in steps">
              <v-stepper-step
                class= "stepper-step"
                :edit-icon="null"
                :key="`${step.id}-step`"
                :complete="checkIfSelected(step.label)"
                :step="step.label"
                :editable="true"
                :color="errors[0] && !errors[1].day.required ? 'red' : step.color"
                @click="addDays(step.label)"
              >
              </v-stepper-step>

              <v-divider
                v-if="step.id !== steps.length"
                :key="step.id"
                :color="steps[step.id].color === '#6DB42C' && steps[step.id-1].color !=='rgba(0, 0, 0, 0.38)' ? '#6DB42C' : 'grey'"
              ></v-divider>
            </template>
          </v-stepper-header>
        </template>
      </v-stepper>

      <v-col class="d-flex mt-0 pt-0" cols="12" sm="12">
        <p class="select-hour-labels">From</p>
        <v-text-field 
          class="select-hour-text-fields"
          v-model="startHour"
          maxlength="2"
          :error="errors[0] && !errors[1].startHour.required || errors[0] && !errors[1].startHour.validateHours"
        >
        </v-text-field>
        <v-select
          :menu-props="{offsetY: true }"
          class='select-hour'
          v-model="hourPostfixFrom"
          :items="hourPostfix"
          :item-text="hours.text"
          append-icon="fas fa-caret-down"
          :disabled="!selectedDays"
        ></v-select>
        <p class="select-hour-labels">To</p>
        <v-text-field 
          class="select-hour-text-fields"
          v-model="stopHour"
          maxlength="2"
          :error="errors[0] && !errors[1].startHour.required || errors[0] && !errors[1].stopHour.validateHours"
        >
        </v-text-field>
        <v-select
          :menu-props="{offsetY: true }"
          class="select-hour"
          v-model="hourPostfixTo"
          :items="hourPostfix"
          :item-text="hours.text"
          append-icon="fas fa-caret-down"
          :disabled="!selectedDays"
       ></v-select>
      </v-col>
  </v-card>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedDays: [],
      steps: [
        { id: 1, label: "Mn", color: "rgba(0, 0, 0, 0.38)" },
        { id: 2, label: "Tu", color: "rgba(0, 0, 0, 0.38)" },
        { id: 3, label: "We", color: "rgba(0, 0, 0, 0.38)" },
        { id: 4, label: "Th", color: "rgba(0, 0, 0, 0.38)" },
        { id: 5, label: "Fd", color: "rgba(0, 0, 0, 0.38)" },
        { id: 6, label: "Sd", color: "rgba(0, 0, 0, 0.38)" },
        { id: 7, label: "Su", color: "rgba(0, 0, 0, 0.38)" }
      ],
      timezones: [
        { name: '(GMT -12:00) Eniwetok, Kwajalein', value: '-12' },
        { name: '(GMT -11:00) Midway Island, Samoa', value: '-11' },
        { name: '(GMT -10:00) Hawaii', value: '-10' },
        { name: '(GMT -9:00) Alaska', value: '-9' },
        { name: '(GMT -8:00) Pacific Time (US Canada)', value: '-8' },
        { name: '(GMT -7:00) Mountain Time (US Canada)', value: '-7' },
        { name: '(GMT -6:00) Central Time (US Canada), Mexico City', value: '-6' },
        { name: '(GMT -5:00) Eastern Time (US Canada), Bogota, Lima', value: '-5' },
        { name: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz', value: '-4' },
        { name: '(GMT -3:00) Brazil, Buenos Aires, Georgetown', value: '-3' },
        { name: '(GMT -2:00) Mid-Atlantic', value: '-2' },
        { name: '(GMT -1:00) Azores, Cape Verde Islands', value: '-1' },
        { name: '(GMT) Western Europe Time, London, Lisbon, Casablanca', value: '+0' },
        { name: '(GMT +1:00) Brussels, Copenhagen, Madrid, Paris', value: '+1' },
        { name: '(GMT +2:00) Kaliningrad, South Africa', value: '+2' },
        { name: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg', value: '+3' },
        { name: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi', value: '+4' },
        { name: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent', value: '+5' },
        { name: '(GMT +6:00) Almaty, Dhaka, Colombo', value: '+6' },
        { name: '(GMT +7:00) Bangkok, Hanoi, Jakarta', value: '+7' },
        { name: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong', value: '+8' },
        { name: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk', value: '+9' },
        { name: '(GMT +10:00) Eastern Australia, Guam, Vladivostok', value: '+10' },
        { name: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia', value: '+11' },
        { name: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka', value: '+12' },
        { name: '(GMT +13:00) Apia, Nukualofa', value: '+13' },
        { name: '(GMT +14:00) Line Islands, Tokelau', value: '+14' }
      ],
      startHour: "",
      stopHour: "",
      hours: [],
      scheduler: [],
      selectedTimezone: "",
      hourPostfix: ["AM", "PM"],
      hourPostfixFrom: "AM",
      hourPostfixTo: "AM",
      schedulerSwitch: false
    };
  },
  props: ["errors"],
  watch: {
    startHour() {
      this.$emit(
        "selectedHours",
        this.startHour,
        this.stopHour,
        this.hourPostfixFrom,
        this.hourPostfixTo
      );
    },
    stopHour() {
      this.$emit(
        "selectedHours",
        this.startHour,
        this.stopHour,
        this.hourPostfixFrom,
        this.hourPostfixTo
      );
    },
    hourPostfixFrom() {
      this.$emit(
        "selectedHours",
        this.startHour,
        this.stopHour,
        this.hourPostfixFrom,
        this.hourPostfixTo
      );
    },
    hourPostfixTo() {
      this.$emit(
        "selectedHours",
        this.startHour,
        this.stopHour,
        this.hourPostfixFrom,
        this.hourPostfixTo
      );
    },
    schedulerSwitch() {
      this.$emit("schedulerSwitch", this.schedulerSwitch);
      if(!this.schedulerSwitch) {
        this.startHour = '';
        this.stopHour = '';
        this.selectedDays = [];
        this.scheduler = [];
        this.selectedTimezone = '';
        this.steps.map(step => step.color = "rgba(0, 0, 0, 0.38)");
      }
    }
  },
  methods: {
    addDays(label) {
      if (this.selectedDays.includes(label)) {
        const result = this.selectedDays.filter(day => day != label);
        this.steps.map(step => {
          if (step.label == label) {
            step.color = "rgba(0, 0, 0, 0.38)";
          }
        });

        this.selectedDays = result;
      } else {
        this.steps.map(step => {
          if (step.label == label) {
            for (let i = step.id; i >= 1; i--) {
              this.selectedDays.push(this.steps[i - 1].label);
              this.steps[i - 1].color = "#6DB42C";

              document.querySelectorAll(".v-stepper__step__step")[
                i - 1
              ].innerHTML = this.steps[i - 1].label;
            }
          }
        });

        this.selectedDays = [...new Set(this.selectedDays)];
      }

      this.prepareScheduler(this.selectedDays);
    },
    prepareScheduler(schedules) {
      this.scheduler = [];
      this.scheduler = schedules.map(schedule => ({
        day: this.steps.find(step => step.label == schedule).id
      }));

      this.$emit("selectedScheduler", this.scheduler);
    },
    checkIfSelected(label) {
      return this.selectedDays.includes(label) ? true : false;
    },
    onSelectedTimezone() {
      this.$emit("selectedTimezone", this.selectedTimezone);
    },
    getCurrentTimezone() {
      let currentTimezone = -(new Date().getTimezoneOffset() / 60);
      currentTimezone.toString().substring(0, 1) != '-' ? currentTimezone = `+${currentTimezone}` : true
      this.timezones.filter(timezone => timezone.value === currentTimezone ? this.selectedTimezone = timezone.value : true)
      this.$emit("selectedTimezone", this.selectedTimezone);
    }
  },
  created() {
    this.getCurrentTimezone()
  }
};
</script>

<style scoped>
@media (min-width: 960px) {
  #scheduler {
    border: 0;
    box-shadow: none;
    border-radius: 0;
    background-color: #f9f9f9;
    padding: 10px;
  }
}

.v-stepper {
  box-shadow: none;
  border-radius: 0;
  background-color: #f9f9f9 !important;
  margin-top: -10px;
  margin-bottom: 20px;
  transition: none !important;
  height: 9vh!important;
}

.v-stepper__header {
  height: 9vh!important;
}

.stepper-step >>> .v-stepper__step__step {
  width: 2vw;
  height: 4vh;
}

.stepper-step:hover {
  background: transparent !important;
}

.select-hour-labels {
  margin-top: 2.5vh;
  margin-right: 0.8vw;
  font: medium 16px/19px "Montserrat" !important;
}

.select-hour-text-fields >>> input {
  font: bold 16px/19px "Montserrat";
  text-align: center !important;
}

.select-hour {
  margin-right: 120px;
  margin-left: 20px;
}

</style>